import { Validator } from 'vee-validate';
import { 	BasicSelect } from 'vue-search-select';
import CryptoJS from 'crypto-js';
import Pagination from './../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import Loader from '../../../../shared/components/loader';
import MasterService from './../../../services/masterdata.service';
import CONSTANT from './../../../../shared/constants/constant';
import VueElementLoading from 'vue-element-loading';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
	name: 'createtc',
	components: {
		BasicSelect,
		CustomExpandableTable,
		Pagination,
		VueElementLoading,
		Treeselect
	},
	props: ['selectedEditRowData'],
	data() {
		return {
			username: '',
			templateName: '',
			templateDescription: '',
			billigDataList: [{
				id: CONSTANT.BILLING_DATA.MONTHLY,
				label: 'Monthly '
			}, {
				id: CONSTANT.BILLING_DATA.FORTNIGHTLY,
				label: 'Fortnightly'
			}, {
				id: CONSTANT.BILLING_DATA.WEEKLY,
				label: 'Weekly'
			}],
			billigcycleitem: {
				value: null,
				text: null
			},
			billingCycle: null,
			pod: '',
			podCharge: '',
			podChargeEnable: false,
			creditPeriod: '',
			creditLimit: '',
			date1: '',
			date2: '',
			advancePayment: '',
			paymentmode: [],
			liabilityAmount: '',
			creditAlert: '',
			isLoading: false,
			innerTableColumn: [],
			action: '',
			oldtemplatename: '',
			cycleError: '',
			listPaymentMode: [{
				text: "Cheque",
				value: CONSTANT.PAYMENT_MODE.CHEQUE
			}, {
				text: "Demand Draft",
				value: CONSTANT.PAYMENT_MODE.DEMAND_DRAFT
			}, {
				text: "RTGS",
				value: CONSTANT.PAYMENT_MODE.RTGS
			}],
			expanded:false,
			accordianTab:{1:false, 2:false, 3:false}
		}
	},
	computed: {

	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata');
		var userToken = window.localStorage.getItem('userToken');
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.username = userdetail.email;
		this.setValues();
	},
	methods: {
		isNumber: function(evt) {
			evt = (evt) ? evt : window.event;
			var charCode = (evt.which) ? evt.which : evt.keyCode;
			if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
			  evt.preventDefault();;
			} else {
			  return true;
			}
		},
		isIntegerOnlty: function(evt) {
			evt = (evt) ? evt : window.event;
			var charCode = (evt.which) ? evt.which : evt.keyCode;
			if (charCode < 48 || charCode > 57) {
			  evt.preventDefault();;
			} else {
			  return true;
			}
		},
		expandAll(){
			this.expanded = true;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = true;
			}
		},
		collapseAll(){
			this.expanded = false;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = false;
			}
		},
		toggleCheck(tabid){
			this.expanded = false;
			for (var key in this.accordianTab) {
				if(tabid != key){
					this.accordianTab[key] = false;
				}
			}
		},
		setValues() {
			this.action = "add";
			if (this.selectedEditRowData.id) {
				this.action = "edit";
				this.pod = this.selectedEditRowData.podhardcopyrequired;
				this.paymentmode = this.selectedEditRowData.paymentmode;
				if (this.selectedEditRowData.billingcycle == CONSTANT.BILLING_DATA.MONTHLY) {
					this.billigcycleitem = {
						id: CONSTANT.BILLING_DATA.MONTHLY,
						label: "Monthly"
					}
					this.billingCycle = CONSTANT.BILLING_DATA.MONTHLY
					this.date1 = this.selectedEditRowData.billsubmissionlastdate.cycle1
					this.date2 = ""

				} else if (this.selectedEditRowData.billingcycle == CONSTANT.BILLING_DATA.FORTNIGHTLY) {
					this.billigcycleitem = {
						id: CONSTANT.BILLING_DATA.FORTNIGHTLY,
						label: "Fortnightly"
					}
					this.billingCycle = CONSTANT.BILLING_DATA.FORTNIGHTLY
					this.date1 = this.selectedEditRowData.billsubmissionlastdate.cycle1;
					this.date2 = this.selectedEditRowData.billsubmissionlastdate.cycle2;
				}else if (this.selectedEditRowData.billingcycle == CONSTANT.BILLING_DATA.WEEKLY){
					this.billigcycleitem = {
						id: CONSTANT.BILLING_DATA.WEEKLY,
						label: "Weekly"
					}
					this.billingCycle = CONSTANT.BILLING_DATA.WEEKLY
				}
					this.oldtemplatename = this.selectedEditRowData.termsconditionname,
					this.creditAlert = this.selectedEditRowData.creditlimitalert,
					this.templateName = this.selectedEditRowData.termsconditionname,
					this.templateDescription = this.selectedEditRowData.termsconditiondscription,
					this.podCharge = this.selectedEditRowData.podhardcopycharges,
					this.creditPeriod = this.selectedEditRowData.creditperioddays,
					this.creditLimit = this.selectedEditRowData.creditlimit,
					this.advancePayment = this.selectedEditRowData.ftladvancepayment,
					this.liabilityAmount = this.selectedEditRowData.maxliability
			}
		},

		selectBillingCycle(obj) {
			this.$nextTick(() => {
				this.date1 = '';
				this.date2 = '';
				this.billigcycleitem = obj;
				this.billingCycle = obj.id;
			})

		},
		changeCycle() {
			if ((this.date1 == this.date2) && (this.date1 > 0 && this.date2 > 0)) {
				this.cycleError = "Dates should be Different"
				return false;
			} else {
				this.cycleError = ''
			}
		},
		showTCFilter() {
			this.$emit("goBackToParent")
		},
		resetAddForm() {
			this.$nextTick(() => {
				this.$validator.reset();
				this.isLoading = false;
				this.templateNameSearch = '';
				this.templateName = '';
				this.templateDescription = '';
				this.billigcycleitem = {
					value: null,
					text: null
				};
				this.billingCycle = '';
				this.pod = '';
				this.podCharge = '';
				this.podChargeEnable = false;
				this.creditPeriod = '';
				this.creditLimit = '';
				this.date1 = '';
				this.date2 = '';
				this.advancePayment = '';
				this.paymentmode = [];
				this.liabilityAmount = '';
				this.creditAlert = '';
			})
		},
		savetc() {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					this.expandAll();
					return false;
				} else {
					if ((this.date1 == this.date2) && (this.date1 > 0 && this.date2 > 0)) {
						this.cycleError = "Dates should be Different"
						return false;
					} else {
						this.cycleError = ''

						if (this.templateName == '' || this.templateName == null) {
							return false;
						}
						if (this.templateDescription == '' || this.templateDescription == null) {
							return false;
						}
						this.saveAddDataa()
					}
				}
			}).catch(() => {
				console.log('errors exist')
			});

		},
		async saveAddDataa() {
			try {
				this.isLoading = true;
				var billingCycle = ''
				let billsubmissionlastdate = {}
				if (this.billingCycle == CONSTANT.BILLING_DATA.MONTHLY) {
					billsubmissionlastdate = {
						"cycle1": this.date1
					}
				} else if (this.billingCycle == CONSTANT.BILLING_DATA.FORTNIGHTLY) {
					billsubmissionlastdate = {
						"cycle1": this.date1,
						"cycle2": this.date2
					}
				}

				let podcharges;
				if(this.pod==1){
					podcharges = this.podCharge;
				}

				var input = {
					"termsconditionname": this.templateName.trim(),
					"termsconditiondscription": this.templateDescription.trim(),
					"billingcycle": this.billingCycle || null,
					"podhardcopyrequired": this.pod || null,
					"podhardcopycharges": podcharges || null,
					"billsubmissionlastdate": billsubmissionlastdate,
					"creditperioddays": this.creditPeriod || null,
					"creditlimit": this.creditLimit || null,
					"ftladvancepayment": this.advancePayment || null,
					"paymentmode": this.paymentmode,
					"maxliability": this.liabilityAmount || null,
					"createdby": this.username,
					"status": CONSTANT.STATUS.ACTIVE,
					"creditlimitalert": this.creditAlert || null
				};
				let result = await MasterService.addtermconditionListing(input);
				this.isLoading = false;
				if (result.data.code == 200) {
					this.$alert(result.data.message, this.templateName, "success");
					this.resetAddForm();
					this.$emit("goBackToParent");
				} else {
					this.$alert(result.data.message, this.templateName, "error");
				}
				this.$validator.reset();
			} catch (err) {
				console.log(err);
			}
		},
		updatadatasubmit() {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				} else {
					if ((this.date1 == this.date2) && (this.date1 > 0 && this.date2 > 0)) {
						this.cycleError = "Dates should be Different"
						return false;
					} else {
						if (this.templateName == '' || this.templateName == null) {
							return false;
						}
						if (this.templateDescription == '' || this.templateDescription == null) {
							return false;
						}
						this.updateData()
					}
				}
			}).catch(() => {
				console.log('errors exist')
			});

		},
		async updateData() {
			var podhardcopyrequired = '';
			var billingCycle = '';
			if (this.billingCycle == "Monthly" || this.billingCycle == CONSTANT.BILLING_DATA.MONTHLY) {
				billingCycle = CONSTANT.BILLING_DATA.MONTHLY
			} else if (this.billingCycle == "Fortnightly" || this.billingCycle == CONSTANT.BILLING_DATA.FORTNIGHTLY) {
				billingCycle = CONSTANT.BILLING_DATA.FORTNIGHTLY
			} else if (this.billingCycle == "Weekly" || this.billingCycle == CONSTANT.BILLING_DATA.WEEKLY) {
				billingCycle = CONSTANT.BILLING_DATA.WEEKLY
			}
			let billsubmissionlastdate = {}
			if (this.billingCycle == CONSTANT.BILLING_DATA.MONTHLY) {
				billsubmissionlastdate = {
					"cycle1": this.date1
				}
			} else if (this.billingCycle == CONSTANT.BILLING_DATA.FORTNIGHTLY) {
				billsubmissionlastdate = {
					"cycle1": this.date1,
					"cycle2": this.date2
				}
			}

			let podcharges;
			if(this.pod==1){
				podcharges = this.podCharge;
			}

			var inputupdate = {
				"termsconditionname": this.oldtemplatename.trim(),
				"termsconditionnamenew": this.templateName.trim(),
				"termsconditiondscription": this.templateDescription.trim(),
				"billingcycle": billingCycle || null,
				"podhardcopyrequired": this.pod || null,
				"podhardcopycharges": podcharges || null,
				"billsubmissionlastdate": billsubmissionlastdate,
				"creditperioddays": this.creditPeriod || null,
				"creditlimit": this.creditLimit || null,
				"ftladvancepayment": this.advancePayment || null,
				"paymentmode": this.paymentmode,
				"maxliability": this.liabilityAmount || null,
				"lastmodifiedby": this.username,
				"status": CONSTANT.STATUS.ACTIVE,
				"creditlimitalert": this.creditAlert || null
			}
			this.isLoading = true
			let result = await MasterService.updatetermconditionListing(inputupdate);
			this.isLoading = false;
			if (result.data.code == 200) {
				this.$alert(result.data.message, this.templateName, "success");
				this.resetAddForm();
				this.$emit("goBackToParent");
			} else {
				this.$alert(result.data.message, this.templateName, "error");
			}
			this.$validator.reset();
			this.isLoading = false
		},
	}
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/tc/createtc/createtc.component.js